import React, { useEffect, useRef } from 'react';

function WaitingComponent(props) {
    const videoRef = useRef(null);
    const videoSrc = '/video/loading_screen_1.mp4';
    return (
        <video
            ref={videoRef}
            autoPlay
            loop
            style={{ height: '100vh', width: '100vw', position: 'static', top: 0, left: 0, zIndex: 1000000 }}
            playsInline muted
            onEnded={() => {
                videoRef.current.currentTime = 0;
                videoRef.current.play();
            }}
        >
            <source src={videoSrc} type="video/mp4" />
        </video>
    );
}

export default WaitingComponent;
